// Module
var code = `<div class="oe-selector" style="{{>visibility}}">
    {{#if showLabel}}
    <terceraLabel text="{{label}}" />
    {{/if}}

    <div class="oe-selector-right">
        <terceraTIFComboBox enabled="{{enabled}}"
                            showLastValue="true"
                            orderType="{{orderTypeId}}"
                            instrument="{{instrument}}"
                            items="{{items}}"
                            selectedItem="{{selectedItem}}"
                            gtdDate="{{gtdDate}}" />
    </div>
</div>`;
// Exports
export default code;